import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { Operator, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { AccountGroupType } from '@model/AccountGroupType'
import { CampaignStatusEnum } from '@model/CampaignStatusEnum'
import { PlatformTypeEnum } from '@model/PlatformTypeEnum'

export const useDepositTradingAccounts = (isCFD: boolean) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.deposit.tradingAccounts(isCFD),
    queryFn: () =>
      apiClient.getTradingAccounts({
        search: {
          AccountGroupType: { value: AccountGroupType.Live, operator: Operator.EQUAL },
          Platform: { value: PlatformTypeEnum.CQGCAST, operator: Operator.NOT_EQUAL },
          Status: { value: CampaignStatusEnum.Enabled, operator: Operator.EQUAL },
        },
        pageSize: 1000,
      }),
    enabled: isCFD,
    refetchOnMount: 'always',
  })

  const tradingAccounts = useMemo(() => data?.items ?? [], [data?.items])

  return { tradingAccounts, isTradingAccountsLoading: isLoading }
}
